function scrollToZero() {
  window.scrollTo(0, 0);
  setTimeout(() => window.scrollTo(0, 0), 0);
  setTimeout(() => window.scrollTo(0, 0), 100);
}

export function fixAppLayoutSize() {
  let lastVH = 0
  function setVh() {
    const vh = (window.visualViewport?.height ?? window.innerHeight) * 0.01;

    if (lastVH === vh) {
      return;
    }

    // checking if keyboard open
    // if (
    //   lastVH * 100 > event?.target.height &&
    //   lastVW * 100 === event?.target.width
    // ) {
    //   return;
    // }
    lastVH = vh;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    scrollToZero();
  }

  setVh();
  (window.visualViewport ?? window).addEventListener("resize", setVh);
}
